"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[732],{

/***/ 60732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_HubBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/rich-text-types.es5.js
var rich_text_types_es5 = __webpack_require__(80865);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
;// CONCATENATED MODULE: ./public/artifacts/images/hub/banner/image-layer.jpg
/* harmony default export */ var image_layer = ({"src":"/_next/static/media/image-layer.e550a514.jpg","height":520,"width":702,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAEAAgICAwAAAAAAAAAAAAABAAMCBBEhIlFx/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABgRAAMBAQAAAAAAAAAAAAAAAAABMREh/9oADAMBAAIRAxEAPwCLR0dhtqyv2lvK6nK08uAekE7fvqIiEu0drIf/2Q==","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/artifacts/images/hub/banner/back-layer.png
/* harmony default export */ var back_layer = ({"src":"/_next/static/media/back-layer.cd800378.png","height":693,"width":890,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAKlBMVEX///////9MaXH////////////////+/v7////////+/v7+/v7///////83tfZVAAAADXRSTlP6PQABumjM5V2eB9+MQUAIWQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC5JREFUeJwVyckRACAMA7GNE27cf7sMX4lU1GFtFNi4oTLGl+z+FGj+KZFqgx56HbYBE4tG5lwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/artifacts/images/hub/banner/front-layer.png
/* harmony default export */ var front_layer = ({"src":"/_next/static/media/front-layer.045ac92d.png","height":693,"width":890,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAADFBMVEVMaXGGsHqErXqFr37J+8OcAAAABHRSTlMAEiJH4zuDlwAAAAlwSFlzAAALEwAACxMBAJqcGAAAACFJREFUeJxjYGBkZGBgYGBkAFMMDEwwBjJgAokxM8N4zAAB2QAWiJVSyAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/hub/components/HubBanner/HubBannerImage.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  position: relative;\n\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n\n  > * {\n    grid-area: 1 / 1 / 2 / 2; // stacking the images on each other\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 10;\n  mask-image: url('/artifacts/images/hub/banner/clippath-layer.svg');\n  mask-size: 100% 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var HubBannerImage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipPathImage, (0,_object_spread/* default */.Z)({
                objectFit: "cover",
                height: 250,
                width: 300
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "",
                src: front_layer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "",
                src: back_layer
            })
        ]
    });
};
var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
var ClipPathImage = (0,styled_components_browser_esm/* default */.ZP)((image_default()))(_templateObject1());
/* harmony default export */ var HubBanner_HubBannerImage = (HubBannerImage);

;// CONCATENATED MODULE: ./src/hub/components/HubBanner/index.tsx


function HubBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 40px;\n  padding: 6px 15px;\n"
    ]);
    HubBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HubBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column-reverse;\n  border-radius: ",
        "px;\n  background: var(\n    --radial-gradient,\n    radial-gradient(\n      92.76% 128.27% at 93.04% 116.94%,\n      #e2ec97 7.76%,\n      #e7f4c3 79.45%\n    )\n  );\n\n  text-align: center;\n\n  margin-top: ",
        "px;\n\n  ",
        " {\n    margin-top: 0px;\n    flex-direction: row;\n    text-align: start;\n  }\n"
    ]);
    HubBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  margin-right: ",
        "px;\n  margin-top: ",
        "px;\n  flex-shrink: 0;\n\n  max-width: 320px;\n\n  ",
        " {\n    padding: 0;\n    width: min(40vw, 280px);\n    margin: ",
        ";\n    max-height: calc(100% - 60px);\n  }\n\n  ",
        " {\n    max-width: 320px;\n    width: auto;\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: stretch;\n  flex-direction: column;\n  padding: ",
        ";\n  align-items: center;\n  height: auto;\n  justify-content: space-around;\n\n  ",
        " {\n    align-items: start;\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var HubBanner = function(props) {
    var ref, ref1;
    var parsedTitle = (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(props.title, {
        renderNode: (0,_define_property/* default */.Z)({}, rich_text_types_es5/* BLOCKS.PARAGRAPH */.RG.PARAGRAPH, function(_, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            });
        }),
        renderMark: (0,_define_property/* default */.Z)({}, rich_text_types_es5/* MARKS.BOLD */.oN.BOLD, function(text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    color: "#006C4C"
                },
                children: text
            });
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HubBanner_Wrapper, {
        as: "aside",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "h4",
                                fontSize: {
                                    xs: 24,
                                    sm: 28,
                                    md: 32
                                },
                                fontWeight: 700,
                                lineHeight: "130%",
                                children: parsedTitle
                            }),
                            props.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                mt: 1,
                                component: "p",
                                lineHeight: "160%",
                                fontWeight: "500",
                                fontSize: {
                                    xs: 14,
                                    sm: 16
                                },
                                children: props.subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        mt: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: props.button.url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HubBannerButton, {
                                variant: "primary",
                                rounded: true,
                                component: "a",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    lineHeight: "172.5%",
                                    children: props.button.text
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HubBanner_HubBannerImage, {
                    src: ((ref = props.image) === null || ref === void 0 ? void 0 : ref.src) || image_layer,
                    alt: ((ref1 = props.image) === null || ref1 === void 0 ? void 0 : ref1.alt) || ""
                })
            })
        ]
    });
};
var HubBannerButton = (0,styled_components_browser_esm/* default */.ZP)(esm/* Button */.zx)(HubBanner_templateObject());
var HubBanner_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(HubBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(8);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 3, 0, 3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(-6);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2, -1, 2, 0);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3, -3, 3, 0);
});
var ContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(2, 2, 3, 2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4, 2, 4, 4);
});
/* harmony default export */ var components_HubBanner = (HubBanner);


/***/ })

}]);